import { combineReducers } from "redux";

import manufacturer from './manufacturer';
import header from './header';
import home from './home';
import login from './login';
import produtos from './products';
import stocks from "./stock";
import users from "./users";

export default combineReducers({
    manufacturer,
    header,
    home,
    login,
    produtos,
    stocks,
    users
});
